<template>
  <div id="cotizr">
    <CotizrHeader />
    <CotizrTable />
    <CotizrFooter />
  </div>
</template>

<script>
import CotizrHeader from './components/CotizrHeader'
import CotizrTable from './components/CotizrTable'
import CotizrFooter from './components/CotizrFooter'

export default {
  name: 'Cotizr',
  components: {
    CotizrHeader,
    CotizrTable,
    CotizrFooter
  }
}
</script>

<style lang="sass">
@import url('https://fonts.googleapis.com/css?family=Kanit:400,700')

$family-sans-serif: "Kanit", sans-serif

@import "~bulma/sass/utilities/_all.sass"
@import "~bulma/sass/base/_all.sass"
@import "~bulma/sass/grid/columns.sass"
@import "~bulma/sass/elements/container.sass"
@import "~bulma/sass/elements/title.sass"
@import "~bulma/sass/elements/icon.sass"
@import "~bulma/sass/elements/image.sass"
@import "~bulma/sass/elements/table.sass"
@import "~bulma/sass/layout/section.sass"

html
  background: #355b4b
</style>
